/* アンカーリンクのヘッダー調整 */
$(function() {
 let headerHight = 100; //ヘッダの高さ
 $("a[href^='#']").click(function(){
    let href= $(this).attr("href");
       let target = $(href == "#" || href == "" ? 'html' : href);
        let position = target.offset().top-headerHight; //ヘッダの高さ分位置をずらす
     $("html, body").animate({scrollTop:position}, 550, "swing");
        return false;
   });
});

/* 別ページへアンカーリンクを飛ばした際のヘッダー調整 */
$(window).on('load', function() {
	const url = $(location).attr('href'),
	headerHeight = $('header').outerHeight() + 30;

	if(url.indexOf("#") != -1){
		const anchor = url.split("#"),
		target = $('#' + anchor[anchor.length - 1]),
		position = Math.floor(target.offset().top) - headerHeight;
		$("html, body").animate({scrollTop:position}, 400);
	}
});

/* NEWSスライダー(TOPページ) */
$(function() {
    setTimeout(function() {
        $("#custom-slide").addClass('appear');
        $("#custom-slide").slick({
            autoplay: false,
            dots: false,
            speed: 800,
            arrows: true,
            draggable: false,
            adaptiveHeight: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 2,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    draggable: true,
                }
            }]
        });
    },700);
});

/* NEWSスライダー(ニュース一覧ページ) */
$(function() {
        $("#custom-slide02").slick({
            autoplay: false,
            dots: false,
            speed: 800,
            arrows: true,
            draggable: false,
            adaptiveHeight: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 2,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                },
                breakpoint: 768,
                settings: 'unslick',
            }]
        });
    });

$(function() {
        $("#scroll-menu-img").slick({
            autoplay: true,
            dots: false,
            speed: 800,
            arrows: true,
            draggable: false,
            adaptiveHeight: true,
            slidesToShow: 7,
            slidesToScroll: 2,
            responsive: [{
                breakpoint: 1000,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    draggable: true,
                },
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    draggable: true,
                }
            }],

        });
    });

    /* モバイルサイズ時にスライダーを止める */
    $(window).on('resize orientationchange', function() {
        $('#cutom-slide02').slick('resize');
});

/* コレクション(DESIGNから選ぶ)用スライドメニュー */
$(function() {
    $("#cutom-slide03").slick({
        autoplay: false,
        dots: false,
        speed: 800,
        arrows: true,
        draggable: true,
        adaptiveHeight: true,
        infinite: true,
        slidesToShow: 10,
        slidesToScroll: 3,
        variableWidth: true,
        responsive: [{
            breakpoint: 650,
            settings: 'unslick',
        }]
    });
});

/* モバイルサイズ時にスライダーを止める */
$(window).on('resize orientationchange', function() {
    $('#cutom-slide03').slick('resize');
});


// カラースウォッチ選択で納期表示
$(function() {
    $('.color-swatch__item').on('click', function() {
        $('.variant-delivery').removeClass('on')
        $(this).next('.variant-delivery').addClass('on')
    });
});
